import React, { useState } from 'react';
import * as Yup from 'yup';
import { Button, Modal, PreviewImage, TextField } from 'src/components';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import ImageUploadWithPreview from 'src/components/image-upload-with-preview';
import useFetch from 'src/hooks/useFetch';
import { Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { fetchCustomer } from 'src/redux/action/customer.action';
import { off } from 'process';
import UploadImage from 'src/components/upload-image';
import { IoIosClose } from 'react-icons/io';
import SlideInModal from 'src/components/slideInModal';

interface IProps {
  handleModal: () => void;
  onClick: () => void;
  showModal: boolean;
  isHidden: boolean;
  fetchData: () => void;
  setEditCustomer: (val: boolean) => void;
  setEditCustomerId: (val: string) => void;
  editCustomer: boolean;
  editCustomerId: string;
  editCustomerData: any;
}

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Full Name must be atleat 3 characters long')
    .required('Full Name is required'),
  // name: Yup.string()
  //   .min(3, 'Full Name must be a least 3 character long')
  //   .required('Full is required'),
  // location: Yup.string()
  //   .min(3, 'Location must be a least 3 character long')
  //   .required('Location is required'),
  // city: Yup.string()
  //   .min(3, 'City must be a at least 3 character long')
  //   .required('City is required'),
  // region: Yup.string()
  //   .min(3, 'Region must be a at least 3 character long')
  //   .required('Region is required'),
  // tempAddress: Yup.string()
  //   .min(3, 'Address must be a least 3 character long')
  //   .required('Address is required'),
  // image: Yup.string(),
  // email: Yup.string()
  //   .email()
  //   .typeError('Please enter a valid email')
  //   .required('Email is required'),
  // phone: Yup.number()
  //   .typeError('Phone number must be in number')
});

const AddEditCustomer: React.FC<IProps> = ({
  handleModal,
  showModal,
  editCustomer,
  editCustomerId,
  setEditCustomer,
  setEditCustomerId,
  editCustomerData,
  onClick,
  isHidden,
}) => {
  // );
  const dispatch = useDispatch();
  const [previewImage, setPreviewImage] = React.useState<any>('');
  // const [isHidden, setIsHidden] = useState(false);
  // const onClick = () => {
  //   setIsHidden(true);
  // };

  const intValues = {
    name: editCustomer ? editCustomerData?.name : '',
    email: editCustomer ? editCustomerData?.email : '',
    phone: editCustomer ? editCustomerData?.phone : '',
    tempAddress: editCustomer ? editCustomerData?.tempAddress : '',
    location: editCustomer ? editCustomerData?.address?.location : '',
    region: editCustomer ? editCustomerData?.address?.region : '',
    city: editCustomer ? editCustomerData?.address?.city : '',
    image: editCustomer ? editCustomerData?.image : '',
    country: 'Nepal',
  };

  const handleSubmitCustomer = async (values: any) => {
    const editPayload = {
      name: values?.name,
      email: values?.email,
      phone: values?.phone,
      id: editCustomerId,
    };
    try {
      if (editCustomer) {
        await Service.put('/users/edit', editPayload);
      } else {
        await Service.post('/users/create', values);
      }
      handleModal();
      toastAlert(
        'success',
        `${values?.name} is successfully ${editCustomer ? 'edited' : 'added'}`
      );
      dispatch(fetchCustomer() as any);
      setEditCustomer(false);
      setEditCustomerId('');
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };

  return (
    <div>
      {showModal && (
        <SlideInModal
          title={editCustomer ? 'Edit Customer' : 'Add Customer'}
          onClick={handleModal}
          showModal={showModal}
          className="bg-pure-white z-[9999]"
        >
          <div className="mt-4">
            <Formik
              initialValues={intValues}
              onSubmit={handleSubmitCustomer}
              validationSchema={FORM_VALIDATION}
              validateOnChange
              enableRein
              itialize
            >
              {({ isSubmitting, isValid, setFieldValue }) => (
                <Form className="mt-5">
                  <div className="">
                    <div className="">
                      <h4 className="text-lg font-medium text-text-black mb-4">
                        Basic Information
                      </h4>
                      <TextField label="Full Name" name="name" />
                      <TextField label="Email Address" name="email" />
                      <TextField label="Phone Number" name="phone" />

                      {/* <div className="relative">
                        <div className="z-90">
                          {typeof editCustomerData?.image === 'string' &&
                            !isHidden && (
                              <div>
                                <img src={editCustomerData?.image} alt="" />
                                {!editCustomerData?.image ? (
                                  ''
                                ) : (
                                  <IoIosClose
                                    className="absolute -top-3 -right-2 bg-primary rounded-full"
                                    size={20}
                                    color="#FFFFFF"
                                    onClick={onClick}
                                  />
                                )}
                              </div>
                            )}
                          {typeof editCustomerData?.image !== 'string' ||
                          isHidden ||
                          !editCustomerData?.image ? (
                            <ImageUploadWithPreview
                              label="Upload Image"
                              previewImage={previewImage}
                              setPreviewImage={setPreviewImage}
                              setFieldValue={setFieldValue}
                            />
                          ) : null}
                        </div>
                      </div> */}
                    </div>
                    {/* <div className="">
                      <h4 className="text-lg font-medium text-text-black mb-4">
                        Address
                      </h4>
                      <TextField label="Temp Address" name="tempAddress" />
                    </div> */}
                  </div>

                  <div className="flex items-center  mt-10">
                    <Button
                      text={editCustomer ? 'Edit customer' : 'add customer'}
                      variant="primary"
                      type="submit"
                      isSubmitting={isSubmitting}
                      isValid={isValid}
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </SlideInModal>
      )}
    </div>
  );
};

export default React.memo(AddEditCustomer);
